export function subdivisionTemplate(renderButton) {
  return `
  <table class="esri-widget__table" summary="List of attributes and values">
  <tbody>
      <tr>
        <th>Name</th>
        <td>{CONVEYAN_1}</td>
      </tr>
      <tr>
        <th>Conveyance ID</th>
        <td>{CONVEYAN_2}</td>
      </tr>
      ${
        renderButton
          ? `<tr>
        <th>Subdivision Plat Map</th>
        <td><a href="https://www.dmcgis.com/images/Subdivision/{Image}.pdf" target="_blank" alt="View Subdivision PDF" class="ui mini button">View PDF</a></td>
    </tr>`
          : ""
      }
    </tbody>
  </table>
    `;
}
